import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Nav } from "../components/Nav";
import { Footer } from "../components/Footer";
import { ProductShowcase } from "../components/ProductShowcase";

const FeaturesPage = () => {
  return (
    <main
      data-testid="features-page"
      className="relative min-h-screen bg-loudar-ink text-white"
    >
      <Nav />

      <section
        data-testid="features-hero"
        className="relative isolate overflow-hidden pt-32 pb-16 md:pt-44 md:pb-24"
      >
        <div className="absolute inset-0 -z-10">
          <img
            src="https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?auto=format&fit=crop&w=1800&q=80"
            alt=""
            className="h-full w-full object-cover opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-loudar-ink via-loudar-ink/85 to-loudar-ink" />
        </div>

        <div className="container-loudar">
          <Link
            to="/"
            className="mb-10 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-white/55 transition-colors hover:text-loudar-orange"
            data-testid="features-back-link"
          >
            <ArrowLeft size={14} /> Back to Loudar
          </Link>

          <span className="label-mono">Features</span>

          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: [0.2, 0.8, 0.2, 1] }}
            data-testid="features-headline"
            className="mt-4 max-w-5xl font-display text-4xl uppercase leading-[0.92] tracking-tight text-white sm:text-5xl md:text-6xl lg:text-7xl"
          >
            The Identity Layer
            <br />
            <span className="text-loudar-orange">For The People Behind The Music.</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="mt-6 max-w-2xl text-base text-white/70 md:text-lg"
            data-testid="features-subtitle"
          >
            An industry that's been built on word-of-mouth — finally made navigable. From
            first credit to first headline tour, Loudar makes reputation portable,
            collaborations verifiable, and opportunity visible.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.22 }}
            className="mt-6 max-w-2xl font-display text-xl uppercase leading-snug tracking-tight text-white sm:text-2xl"
            data-testid="features-promise"
          >
            LOUDAR helps you build your network and open doors that were once{" "}
            <span className="text-loudar-orange">out of reach.</span>
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.3 }}
            className="mt-9 flex flex-wrap items-center gap-4"
          >
            <Link to="/pilot" className="btn-primary" data-testid="features-cta-apply">
              Join the waiting list <ArrowRight size={16} />
            </Link>
            <a href="#features" className="btn-ghost" data-testid="features-cta-scroll">
              Explore the platform
            </a>
          </motion.div>
        </div>
      </section>

      <ProductShowcase />

      {/* Closing CTA strip */}
      <section className="relative border-t border-white/[0.06] bg-loudar-surface py-16">
        <div className="container-loudar flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
          <div>
            <span className="label-mono">Ready when you are</span>
            <h3 className="mt-3 font-display text-3xl uppercase leading-tight tracking-tight text-white md:text-4xl">
              Get on the waiting list.
            </h3>
          </div>
          <Link
            to="/pilot"
            className="btn-primary"
            data-testid="features-bottom-cta"
          >
            Join the waiting list <ArrowRight size={16} />
          </Link>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default FeaturesPage;
